<script>
import { VProgressLinear } from 'vuetify/lib';
export default VProgressLinear;
</script>
